import React from 'react';
import { Box, Button } from 'fw/components'
import { ContentHeader, ContentBody } from 'areas/shared/components';
import { Col, Row } from "react-bootstrap";
import * as App from 'modules/app/App'
import MembershipSummary from './membershipSummary/MembershipSummary';
import MembersStatus from './membersStatus/MembersStatus';
import InvoicesStatus from './invoicesStatus/InvoicesStatus';
import ExpiringMemberships from './expiringMemberships/ExpiringMemberships';

class AdminSponsorDashboard extends React.Component {
	constructor(props) {
		super(props);
		this.state = this.initialState(props);
	}

	initialState = () => {
		return {};
	}

	onMemberSearchClick = () => {
		this.props.history.push('/admin/sponsorSetup');
    }

	onPayPalInvoicesClick = () => {
		this.props.history.push('/admin/paypalInvoiceSetup');
    }

	render() {

		return (
			App.hasPrivilege("AdminSponsorDashboardAccess") ?
				<React.Fragment>
					<ContentHeader title={"Memberships – "} description={"Manage and Service Memberships within VOCS"}>
					</ContentHeader>
					<ContentBody>
						<Box>
							<Row>
								<Col md={4}>
									<ContentHeader title={"Membership Summary"} />
									<ContentBody>
										<MembershipSummary />
									</ContentBody>
									</Col>
								<Col md={5}>
									<ContentHeader title={"Member Status"} />
									<ContentBody>
										<MembersStatus />
									</ContentBody>
									<ContentHeader title={"Invoice Status"} />
									<ContentBody>
										<InvoicesStatus />
									</ContentBody>
								</Col>
								<Col md={3}>
									<Button
										id="btnPayPalInvoices"
										onClick={this.onPayPalInvoicesClick}
										bsStyle="default"
										className="pull-right">
										PayPal
									</Button>
									<Button
										id="btnMemberSearch"
										onClick={this.onMemberSearchClick}
										bsStyle="primary"
										style={{ marginRight: 10 }}
										className="pull-right">
										Member Search
									</Button>
								</Col>
							</Row>
							<Row>
								<Col md={12}>
									<ExpiringMemberships />
								</Col>
							</Row>
						</Box>
					</ContentBody>
				</React.Fragment >
				: null
		)
	}
}

export default AdminSponsorDashboard;



// WEBPACK FOOTER //
// ./src/areas/main/dashboard/adminSponsorDashboard/AdminSponsorDashboard.js